var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.468 43.4316C14.4773 39.1278 16.6817 32.4663 20.9612 29.9309C21.7848 29.4465 22.8829 28.7844 23.5046 28.4129L23.7792 25.5545C23.545 25.4334 23.2947 25.2962 23.0525 25.1427L23.0202 25.1266L22.9313 25.062C22.3338 24.6663 21.8817 24.1738 21.704 23.326L21.3649 21.8322L20.1941 16.5999C20.1537 16.4384 20.1133 16.2688 20.081 16.0993L20.0487 15.9701H20.0568C19.9922 15.5664 19.9518 15.1546 19.9438 14.7024C19.8873 10.116 23.0444 4.49618 26.9928 2.15456C28.8015 1.08065 30.2872 0.830342 31.5549 1.37134L31.7326 1.42786L31.8295 1.48438C31.9748 1.55705 32.1202 1.62972 32.2574 1.71854L35.5922 3.55953L35.7698 3.93096L34.1469 5.15829C34.1953 5.49742 34.2276 5.8527 34.2276 6.2322C34.2276 6.66823 34.2276 6.99928 34.1872 7.45145L34.163 7.55642L34.1307 7.83903C34.0984 8.08934 34.0661 8.22661 34.0177 8.47692L32.6935 16.8098C32.4754 18.2955 31.6841 20.298 30.6748 21.7837L31.014 24.0446C31.6357 23.6732 32.75 22.9465 33.5655 22.462C35.2369 21.4688 36.4643 21.4123 37.5866 21.9533L37.74 22.0179L38.1276 22.2359C38.1276 22.2359 38.1276 22.2359 38.1357 22.2359L41.0587 23.8589L40.4046 24.9167C40.7599 25.5868 41.0587 26.2813 41.2928 26.9353C41.8015 28.3322 40.7438 30.7142 39.2177 31.6266L27.6549 38.4819L27.1543 38.7806L18.2158 44.0775C18.0947 45.1514 17.909 46.5887 17.8121 47.3477C17.7798 47.5899 17.5133 47.7272 17.2953 47.6061L14.0413 45.7974C13.4599 45.4744 13.1935 44.6185 13.4599 43.4477L13.468 43.4316Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7746 45.0629C14.784 40.7592 16.9883 34.0977 21.2678 31.5623C22.0914 31.0778 23.1895 30.4157 23.8113 30.0443L30.9734 33.9927L31.5628 29.584L28.2523 27.5008L24.32 26.6772L24.0939 25.5225C23.4964 25.1269 23.3995 24.6586 23.2218 23.8107L21.6715 23.4635L20.5007 18.2312C20.4603 18.0698 20.42 17.9002 20.3877 17.7306L20.3554 17.6014H20.3635C20.2989 17.1977 20.2585 16.7859 20.2504 16.3337C20.1939 11.7474 23.351 6.12753 27.2995 3.78591C29.1082 2.712 30.5939 2.46169 31.8616 3.00268L32.0392 3.0592L32.1361 3.11573C32.2815 3.1884 32.4268 3.26107 32.5641 3.34989L35.8988 5.19088L36.0765 5.56231L34.4535 6.78964C34.502 7.12877 34.5343 7.48405 34.5343 7.86355C34.5343 8.29957 34.5343 8.63063 34.4939 9.0828L34.4697 9.18777L34.4374 9.47038C34.4051 9.72069 34.3728 9.85796 34.3243 10.1083L33.0001 18.4412C32.7821 19.9269 31.9908 21.9294 30.9815 23.4151L31.3206 25.676C31.9423 25.3045 33.0566 24.5778 33.8721 24.0933C35.5436 23.1002 36.7709 23.0437 37.8933 23.5847L38.0467 23.6493L38.4342 23.8673C38.4342 23.8673 38.4342 23.8673 38.4423 23.8673L41.3653 25.4902L40.7113 26.548C41.0665 27.2182 41.3653 27.9126 41.5995 28.5666C42.1082 29.9635 41.0504 32.3455 39.5243 33.2579L27.9616 40.1132L27.461 40.412L18.5225 45.7089C18.4013 46.7828 18.256 45.6685 18.1591 46.4194C18.1268 46.6617 17.8604 46.7989 17.6423 46.6778L15.2684 46.5082L15.1715 45.4182C14.5902 45.0952 13.5082 46.2418 13.7827 45.071L13.7746 45.0629Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4726 47.9372C17.5695 47.9372 17.6744 47.913 17.7633 47.8646C17.957 47.7677 18.0862 47.582 18.1185 47.364C18.2154 46.6453 18.385 45.2969 18.5061 44.2391L39.3707 31.8609C41.0179 30.8838 42.1322 28.3323 41.5831 26.8062C41.3409 26.136 41.0663 25.4981 40.7595 24.9087L41.4943 23.7298L37.7073 21.6466C36.4396 21.0248 35.067 21.1944 33.4117 22.1714C32.9757 22.4298 32.4508 22.7609 31.9663 23.0677C31.716 23.2292 31.4738 23.3826 31.2558 23.5118L31.0055 21.8323C31.9825 20.3627 32.7819 18.3683 33.008 16.8342L34.3645 8.32361C34.3968 8.17019 34.421 8.041 34.4452 7.85529L34.4937 7.50001C34.5583 6.97516 34.5502 6.60373 34.5421 6.20808C34.5421 5.90932 34.5179 5.61057 34.4775 5.27951L36.1651 4.01181L35.834 3.32548L32.4104 1.43604C32.2813 1.34722 32.1278 1.26647 31.9583 1.1938L31.8856 1.15343L31.6514 1.07268C30.3111 0.499391 28.7285 0.76585 26.8309 1.88821C22.8018 4.27827 19.5719 10.0273 19.6285 14.7025C19.6285 15.0578 19.6608 15.4211 19.7173 15.8006H19.7011L19.7738 16.164C19.8061 16.3335 19.8465 16.5112 19.8869 16.6807L21.3968 23.3907C21.6148 24.4404 22.2365 24.9652 22.7533 25.3124L22.8341 25.3689C23.0521 25.5143 23.2539 25.6273 23.4477 25.7323L23.2055 28.2273L20.7912 29.6646C16.544 32.1838 14.2993 38.5062 13.1527 43.359C12.862 44.6025 13.1365 45.6279 13.8794 46.0478L17.1334 47.8565C17.2303 47.913 17.3434 47.9372 17.4564 47.9372H17.4726ZM40.6303 23.964L40.0489 24.9006L40.1297 25.054C40.4527 25.6596 40.7434 26.3217 41.0017 27.0323C41.462 28.3 40.4608 30.5205 39.0558 31.3522L17.9247 43.8838L17.9086 44.0372C17.7956 45.1031 17.6098 46.5484 17.5049 47.2994L14.1943 45.5149C13.7098 45.2403 13.5403 44.4571 13.7664 43.5043C14.6788 39.6205 16.8428 32.7329 21.1142 30.1975L23.7949 28.5987L24.1018 25.377L23.916 25.2801C23.69 25.1671 23.4477 25.0379 23.2216 24.8845L23.1167 24.8118C22.4626 24.3758 22.1477 23.9317 22.0105 23.2615L20.4924 16.5354C20.4521 16.3658 20.4117 16.2124 20.3794 16.0429L20.3633 15.9137C20.2906 15.4857 20.2583 15.0901 20.2502 14.7025C20.1937 10.2211 23.2943 4.70622 27.1539 2.42113C28.8657 1.40374 30.2707 1.15343 31.4415 1.65405L31.6837 1.75094C31.8372 1.82361 31.9663 1.89628 32.0955 1.97703L35.3899 3.83417L33.8235 5.01305L33.8477 5.19069C33.8962 5.57019 33.9285 5.90125 33.9285 6.22423C33.9285 6.6764 33.9285 6.98324 33.8881 7.40311L33.8719 7.47578L33.8316 7.79069C33.8073 7.96025 33.7831 8.0733 33.7589 8.21056L33.7185 8.40435L32.3943 16.7534C32.1763 18.2472 31.385 20.1932 30.4241 21.5981L30.3595 21.695L30.7794 24.5211L31.175 24.2869C31.4657 24.1174 31.8695 23.859 32.2893 23.5925C32.7738 23.2857 33.2906 22.9627 33.7185 22.7043C35.1962 21.8242 36.3508 21.6708 37.449 22.2118L37.6185 22.2845L40.6222 23.9559L40.6303 23.964Z",
    fill: "url(#paint0_linear_2953_26067)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0537 45.4265C18.063 41.1228 20.2673 34.4613 24.5468 31.9259C25.3704 31.4415 26.4686 30.7793 27.0903 30.4079L27.3648 27.5495C26.5251 27.1297 25.54 26.5241 25.2897 25.321L24.9506 23.8272L23.7798 18.5949C23.7394 18.4334 23.699 18.2638 23.6667 18.0943L23.6344 17.9651H23.6425C23.5779 17.5613 23.5375 17.1495 23.5294 16.6974C23.4729 12.111 26.6301 6.49116 30.5785 4.14955C34.527 1.80794 37.7729 3.63278 37.8214 8.21911C37.8214 8.65514 37.8214 8.98619 37.781 9.43837L37.7568 9.54334L37.7245 9.82594C37.6922 10.0763 37.6599 10.2135 37.6114 10.4638L36.2872 18.7967C36.0692 20.2825 35.2779 22.2849 34.2686 23.7707L34.6077 26.0315C35.2294 25.6601 36.3437 24.9334 37.1593 24.4489C41.4549 21.9054 43.7804 25.87 44.8866 28.9222C45.3953 30.3191 44.3375 32.7011 42.8114 33.6135L31.2487 40.4688L30.7481 40.7675L19.2257 47.5986C17.6916 48.5029 16.6015 47.4048 17.0698 45.4265H17.0537Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.192 48.2281C18.5635 48.2281 18.9591 48.107 19.3709 47.8648L42.9566 33.8797C44.6038 32.9027 45.7181 30.3511 45.169 28.825C44.4504 26.8387 43.1585 24.3114 41.051 23.5604C39.8156 23.1163 38.451 23.3263 36.9976 24.1903C36.5616 24.4486 36.0448 24.7716 35.5604 25.0785C35.302 25.2399 35.0597 25.3934 34.8417 25.5306L34.5914 23.8511C35.5684 22.3816 36.3678 20.3872 36.5939 18.853L37.9504 10.3344C37.9827 10.1809 38.0069 10.0518 38.0312 9.86604L38.0796 9.51076C38.1442 8.98592 38.1361 8.61449 38.1281 8.21884C38.1038 5.8853 37.2802 4.1412 35.8107 3.3176C34.3411 2.494 32.4274 2.69586 30.4169 3.88282C26.3877 6.27288 23.1579 12.0219 23.2144 16.6971C23.2144 17.0443 23.2467 17.4077 23.3032 17.7872H23.2871L23.3597 18.1586C23.392 18.3281 23.4324 18.4977 23.4728 18.6754L24.9827 25.3853C25.233 26.5965 26.1293 27.2586 27.0337 27.7269L26.7914 30.2219L24.3771 31.6592C20.1299 34.1784 17.8852 40.4927 16.7386 45.3536C16.4641 46.5163 16.6821 47.4853 17.32 47.9536C17.5703 48.1312 17.861 48.2281 18.1759 48.2281H18.192ZM39.7591 23.948C40.1386 23.948 40.502 24.0126 40.8492 24.1337C42.7305 24.812 43.9256 27.1698 44.5958 29.0269C45.056 30.2946 44.0548 32.5151 42.6498 33.3468L19.0641 47.3318C18.515 47.6548 18.0386 47.7033 17.7076 47.461C17.2796 47.1461 17.1504 46.3952 17.3604 45.4989C18.2728 41.6151 20.4368 34.7275 24.7163 32.1921L27.397 30.5934L27.7038 27.3716L27.5181 27.2747C26.6542 26.8387 25.8225 26.2977 25.6045 25.2561L24.0865 18.53C24.0461 18.3604 24.0057 18.207 23.9734 18.0375L23.9492 17.9083C23.8765 17.4803 23.8442 17.0847 23.8361 16.6971C23.7877 12.2157 26.8802 6.70083 30.7399 4.41574C32.5486 3.34182 34.2442 3.13996 35.5119 3.85859C36.7796 4.56915 37.4902 6.11946 37.5144 8.22691C37.5144 8.67909 37.5144 8.99399 37.474 9.40579L37.4579 9.47846L37.4175 9.79337C37.3933 9.95486 37.3771 10.076 37.3448 10.2132L37.3045 10.4151L35.9802 18.7642C35.7622 20.258 34.9709 22.2039 34.01 23.6089L33.9455 23.7058L34.3653 26.5319L34.761 26.2977C35.0517 26.1201 35.4554 25.8698 35.8914 25.5952C36.3678 25.2884 36.8846 24.9654 37.3125 24.7151C38.1765 24.2064 38.992 23.948 39.7591 23.948Z",
    fill: "url(#paint1_linear_2953_26067)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9122 15.3079L20.1867 12.1992L23.7718 14.2179L23.3681 16.3657L24.9668 24.1334L25.0718 24.1899L25.4836 25.8613L26.8159 27.3309L27.373 27.557L27.0985 30.4073L23.5134 28.4129L23.788 25.5545L22.1731 24.634L21.624 22.7526L21.4302 22.0986L19.9122 15.3079Z",
    fill: "url(#paint2_linear_2953_26067)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9014 42.2931L14.4455 40.2422L13.525 42.8099L13.3877 44.4167L13.6703 45.644L17.3039 47.59L16.9486 46.0881L17.6591 42.9068L17.9014 42.2931Z",
    fill: "url(#paint3_linear_2953_26067)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30545 12.5625C1.30545 8.11341 4.64023 2.63888 8.5806 0.862482C10.0421 0.208446 11.2533 0.143849 12.2626 0.692917L12.3837 0.757513C12.3837 0.757513 12.3998 0.773663 12.4079 0.773663L15.6054 2.65503C15.7508 2.74385 15.7912 2.93764 15.6943 3.0749L14.3539 4.89167C14.4023 8.07304 12.7148 11.8035 10.3005 14.3389V17.0115C10.3005 17.5122 9.79178 18.0693 9.4688 17.924L7.3129 16.9469L6.53774 18.3358C6.44892 18.4892 6.25513 18.5376 6.10979 18.4569L3.24334 16.7935C2.04831 16.1153 1.30545 14.6538 1.30545 12.5544V12.5625Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61209 14.1367C1.61209 9.68763 4.94687 4.2131 8.88724 2.4367C10.3487 1.78266 11.5599 1.71807 12.5692 2.26714L12.6903 2.33173C12.6903 2.33173 12.7065 2.34788 12.7146 2.34788L15.9121 4.22925C16.0574 4.31807 16.0978 4.51185 16.0009 4.64912L14.6605 6.46589C14.709 9.64725 13.0214 13.3777 10.6071 15.9131V18.5858C10.6071 19.0864 8.84686 17.9802 8.52388 17.8348L7.61954 18.5212L6.76364 17.7056L4.75308 17.6653V16.4864C3.55805 15.8162 1.60401 16.2199 1.60401 14.1205L1.61209 14.1367Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27108 18.812C6.3276 18.812 6.38412 18.812 6.43257 18.7878C6.59406 18.7394 6.73133 18.6425 6.81207 18.489L7.44996 17.3425L9.34748 18.1984C9.54934 18.2872 9.77543 18.2549 10.0015 18.1176C10.3083 17.9238 10.6152 17.4797 10.6152 17.0114V14.4599C13.1021 11.8114 14.6767 8.11328 14.6686 4.98844L15.9524 3.25242C16.0493 3.11515 16.0897 2.94558 16.0574 2.77602C16.0251 2.61453 15.9201 2.46919 15.7748 2.38037L12.4077 0.410181C11.3177 -0.187334 10.0257 -0.130812 8.45928 0.571672C4.48661 2.35614 0.998415 7.95179 0.998415 12.5462C0.998415 14.6052 1.68475 16.1555 2.9363 16.9549L3.08972 17.0518L5.95617 18.7151C6.05307 18.7717 6.15804 18.7959 6.26301 18.7959L6.27108 18.812ZM7.19158 16.5592L6.27916 18.1984L3.40462 16.5269C2.25804 15.881 1.62015 14.4679 1.62015 12.5623C1.62015 8.17788 4.93879 2.84869 8.71766 1.14496C10.0984 0.523225 11.2127 0.466703 12.1332 0.967324L12.2624 1.03192L15.476 2.92136L14.063 4.79465V4.89962C14.1034 7.88719 12.5127 11.5934 10.0903 14.1288L10.0015 14.2176V17.0195C10.0015 17.3344 9.69468 17.6493 9.58971 17.6493L7.19158 16.5592Z",
    fill: "url(#paint4_linear_2953_26067)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45533 14.395C4.45533 9.94593 7.79011 4.4714 11.7305 2.69501C14.6696 1.37886 17.0758 2.69501 17.4553 5.86022C17.8591 9.21115 16.0907 13.4099 13.4504 16.1714V18.8441C13.4504 19.3447 12.9417 19.9018 12.6187 19.7565L10.0671 18.6018C6.89384 19.918 4.44726 18.19 4.44726 14.3869L4.45533 14.395Z",
    fill: "#222222"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7393 20.0959C12.8766 20.0959 13.0139 20.0475 13.1511 19.9587C13.458 19.7649 13.7648 19.3208 13.7648 18.8525V16.3009C16.5182 13.3618 18.1654 9.0742 17.7698 5.82824C17.576 4.21334 16.8493 2.97793 15.735 2.34812C14.6046 1.71023 13.135 1.73446 11.6089 2.42079C7.63624 4.20526 4.14805 9.80091 4.14805 14.3953C4.14805 16.4059 4.81016 17.9562 6.02134 18.7636C7.10332 19.4823 8.53251 19.5469 10.0667 18.9413L12.4971 20.0394C12.5698 20.0717 12.6505 20.0879 12.7393 20.0879V20.0959ZM13.894 2.50154C14.4592 2.50154 14.9841 2.63073 15.4362 2.88104C16.381 3.41396 16.9946 4.48787 17.1642 5.90091C17.5437 9.00961 15.9288 13.1438 13.24 15.9618L13.1511 16.0506V18.8525C13.1511 19.1674 12.8443 19.4823 12.7393 19.4823L10.0828 18.2792L9.96171 18.3276C8.58096 18.9009 7.29711 18.8767 6.36854 18.2549C5.335 17.5686 4.76979 16.1959 4.76979 14.3953C4.76979 10.0108 8.08842 4.68166 11.8673 2.97793C12.5779 2.66303 13.2642 2.50154 13.894 2.50154Z",
    fill: "url(#paint5_linear_2953_26067)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02048 10.9875L1.85527 9.14648L1.3062 10.7856V13.5471L1.61303 15.0167L3.93849 17.3098L5.80371 18.198L4.45527 15.4608V12.562L5.02048 10.9875Z",
    fill: "url(#paint6_linear_2953_26067)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8124 10.5849C12.8124 11.3116 13.3211 11.6022 13.9428 11.2389C14.5726 10.8755 15.0732 9.99542 15.0732 9.27679C15.0732 8.55815 14.5645 8.25939 13.9428 8.62275C13.313 8.9861 12.8124 9.86623 12.8124 10.5849Z",
    fill: "#222222"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8221 10.8107C14.0159 10.8107 14.2177 10.7461 14.4277 10.625C15.1221 10.2213 15.6631 9.28463 15.6631 8.48526C15.6631 8.05731 15.5097 7.73432 15.2271 7.57283C14.9445 7.41134 14.5892 7.44364 14.2177 7.65358C13.5233 8.05731 12.9823 8.99395 12.9823 9.79333C12.9823 10.2213 13.1358 10.5443 13.4184 10.7058C13.5395 10.7784 13.6687 10.8107 13.814 10.8107H13.8221ZM14.8395 7.87967C14.9122 7.87967 14.9768 7.89582 15.0333 7.92811C15.1786 8.00886 15.2594 8.2188 15.2594 8.48526C15.2594 9.13122 14.791 9.94675 14.2258 10.2697C13.9917 10.407 13.7736 10.4312 13.6283 10.3505C13.483 10.2697 13.4022 10.0598 13.4022 9.79333C13.4022 9.14737 13.8705 8.33184 14.4358 8.00886C14.5811 7.92811 14.7184 7.87967 14.8395 7.87967Z",
    fill: "url(#paint7_linear_2953_26067)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66393 12.4091C9.66393 13.1358 10.1726 13.4265 10.7944 13.0631C11.4242 12.6998 11.9248 11.8196 11.9248 11.101C11.9248 10.3824 11.4161 10.0836 10.7944 10.447C10.1726 10.8103 9.66393 11.6904 9.66393 12.4091Z",
    fill: "#222222"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6737 12.6267C10.8674 12.6267 11.0693 12.5621 11.2792 12.441C11.9737 12.0373 12.5146 11.1006 12.5146 10.3013C12.5146 9.87332 12.3612 9.55034 12.0786 9.38885C11.796 9.22735 11.4407 9.25158 11.0693 9.46959C10.3749 9.87332 9.83391 10.81 9.83391 11.6093C9.83391 12.0373 9.98732 12.3603 10.2699 12.5218C10.391 12.5944 10.5202 12.6267 10.6656 12.6267H10.6737ZM11.691 9.69568C11.7637 9.69568 11.8283 9.71183 11.8848 9.74412C12.0302 9.82487 12.1109 10.0348 12.1109 10.3013C12.1109 10.9472 11.6345 11.7628 11.0774 12.0857C10.8432 12.223 10.6252 12.2472 10.4799 12.1665C10.3345 12.0857 10.2538 11.8758 10.2538 11.6093C10.2538 10.9634 10.7302 10.1479 11.2873 9.82487C11.4327 9.74412 11.5699 9.69568 11.691 9.69568Z",
    fill: "url(#paint8_linear_2953_26067)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51355 14.2265C6.51355 14.9532 7.02224 15.2439 7.64398 14.8805C8.26572 14.5171 8.77441 13.637 8.77441 12.9184C8.77441 12.1998 8.26572 11.901 7.64398 12.2644C7.01417 12.6277 6.51355 13.5078 6.51355 14.2265Z",
    fill: "#222222"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52327 14.4441C7.71706 14.4441 7.91892 14.3795 8.12886 14.2584C8.82327 13.8547 9.36426 12.918 9.36426 12.1186C9.36426 11.6907 9.21084 11.3677 8.92823 11.2062C8.64562 11.0447 8.29034 11.069 7.91892 11.287C7.22451 11.6907 6.68351 12.6273 6.68351 13.4267C6.68351 13.8547 6.83693 14.1777 7.11954 14.3391C7.24066 14.4118 7.36985 14.4441 7.51519 14.4441H7.52327ZM8.54066 11.5131C8.61333 11.5131 8.67792 11.5292 8.73445 11.5615C8.87979 11.6423 8.96053 11.8522 8.96053 12.1186C8.96053 12.7646 8.48414 13.5801 7.92699 13.9031C7.69283 14.0404 7.47482 14.0646 7.32948 13.9839C7.18413 13.9031 7.10339 13.6932 7.10339 13.4267C7.10339 12.7808 7.57979 11.9652 8.13693 11.6423C8.28227 11.5615 8.41954 11.5131 8.54066 11.5131Z",
    fill: "url(#paint9_linear_2953_26067)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8572 49.899C21.6311 50.0282 21.6311 50.2381 21.8572 50.3673C22.0833 50.4965 22.4385 50.4965 22.6646 50.3673C22.8907 50.2381 22.8907 50.0282 22.6646 49.899C22.4385 49.7698 22.0833 49.7698 21.8572 49.899Z",
    fill: "url(#paint10_radial_2953_26067)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7497 48.6878C19.5236 48.817 19.5236 49.027 19.7497 49.1562C19.9758 49.2853 20.3311 49.2853 20.5572 49.1562C20.7833 49.027 20.7833 48.817 20.5572 48.6878C20.3311 48.5586 19.9758 48.5586 19.7497 48.6878Z",
    fill: "url(#paint11_radial_2953_26067)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9565 48.6878C23.7305 48.817 23.7305 49.027 23.9565 49.1562C24.1826 49.2853 24.5379 49.2853 24.764 49.1562C24.9901 49.027 24.9901 48.817 24.764 48.6878C24.5379 48.5586 24.1826 48.5586 23.9565 48.6878Z",
    fill: "url(#paint12_radial_2953_26067)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8572 47.4686C21.6311 47.5978 21.6311 47.8077 21.8572 47.9369C22.0833 48.0661 22.4385 48.0661 22.6646 47.9369C22.8907 47.8077 22.8907 47.5978 22.6646 47.4686C22.4385 47.3394 22.0833 47.3394 21.8572 47.4686Z",
    fill: "url(#paint13_radial_2953_26067)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.064 47.4686C25.8379 47.5978 25.8379 47.8077 26.064 47.9369C26.2901 48.0661 26.6454 48.0661 26.8714 47.9369C27.0975 47.8077 27.0975 47.5978 26.8714 47.4686C26.6454 47.3394 26.2901 47.3394 26.064 47.4686Z",
    fill: "url(#paint14_radial_2953_26067)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9565 46.2574C23.7305 46.3866 23.7305 46.5965 23.9565 46.7257C24.1826 46.8549 24.5379 46.8549 24.764 46.7257C24.9901 46.5965 24.9901 46.3866 24.764 46.2574C24.5379 46.1282 24.1826 46.1282 23.9565 46.2574Z",
    fill: "url(#paint15_radial_2953_26067)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1634 46.2574C27.9373 46.3866 27.9373 46.5965 28.1634 46.7257C28.3895 46.8549 28.7447 46.8549 28.9708 46.7257C29.1969 46.5965 29.1969 46.3866 28.9708 46.2574C28.7447 46.1282 28.3895 46.1282 28.1634 46.2574Z",
    fill: "url(#paint16_radial_2953_26067)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.064 45.0381C25.8379 45.1673 25.8379 45.3773 26.064 45.5065C26.2901 45.6357 26.6454 45.6357 26.8714 45.5065C27.0975 45.3773 27.0975 45.1673 26.8714 45.0381C26.6454 44.9089 26.2901 44.9089 26.064 45.0381Z",
    fill: "url(#paint17_radial_2953_26067)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2708 45.0381C30.0447 45.1673 30.0447 45.3773 30.2708 45.5065C30.4969 45.6357 30.8522 45.6357 31.0783 45.5065C31.3044 45.3773 31.3044 45.1673 31.0783 45.0381C30.8522 44.9089 30.4969 44.9089 30.2708 45.0381Z",
    fill: "url(#paint18_radial_2953_26067)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1634 43.827C27.9373 43.9562 27.9373 44.1661 28.1634 44.2953C28.3895 44.4245 28.7447 44.4245 28.9708 44.2953C29.1969 44.1661 29.1969 43.9562 28.9708 43.827C28.7447 43.6978 28.3895 43.6978 28.1634 43.827Z",
    fill: "url(#paint19_radial_2953_26067)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3944 43.8108C32.1683 43.94 32.1683 44.1499 32.3944 44.2791C32.6205 44.4083 32.9758 44.4083 33.2019 44.2791C33.428 44.1499 33.428 43.94 33.2019 43.8108C32.9758 43.6816 32.6205 43.6816 32.3944 43.8108Z",
    fill: "url(#paint20_radial_2953_26067)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.287 42.5996C30.0609 42.7288 30.0609 42.9388 30.287 43.068C30.5131 43.1971 30.8683 43.1971 31.0944 43.068C31.3205 42.9388 31.3205 42.7288 31.0944 42.5996C30.8683 42.4704 30.5131 42.4704 30.287 42.5996Z",
    fill: "url(#paint21_radial_2953_26067)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5019 42.5996C34.2758 42.7288 34.2758 42.9388 34.5019 43.068C34.728 43.1971 35.0832 43.1971 35.3093 43.068C35.5354 42.9388 35.5354 42.7288 35.3093 42.5996C35.0832 42.4704 34.728 42.4704 34.5019 42.5996Z",
    fill: "url(#paint22_radial_2953_26067)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3944 41.3804C32.1683 41.5096 32.1683 41.7195 32.3944 41.8487C32.6205 41.9779 32.9758 41.9779 33.2019 41.8487C33.428 41.7195 33.428 41.5096 33.2019 41.3804C32.9758 41.2512 32.6205 41.2512 32.3944 41.3804Z",
    fill: "url(#paint23_radial_2953_26067)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6012 41.3804C36.3752 41.5096 36.3752 41.7195 36.6012 41.8487C36.8273 41.9779 37.1826 41.9779 37.4087 41.8487C37.6348 41.7195 37.6348 41.5096 37.4087 41.3804C37.1826 41.2512 36.8273 41.2512 36.6012 41.3804Z",
    fill: "url(#paint24_radial_2953_26067)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5019 40.1692C34.2758 40.2984 34.2758 40.5083 34.5019 40.6375C34.728 40.7667 35.0832 40.7667 35.3093 40.6375C35.5354 40.5083 35.5354 40.2984 35.3093 40.1692C35.0832 40.04 34.728 40.04 34.5019 40.1692Z",
    fill: "url(#paint25_radial_2953_26067)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7087 40.1692C38.4826 40.2984 38.4826 40.5083 38.7087 40.6375C38.9348 40.7667 39.2901 40.7667 39.5162 40.6375C39.7422 40.5083 39.7422 40.2984 39.5162 40.1692C39.2901 40.04 38.9348 40.04 38.7087 40.1692Z",
    fill: "url(#paint26_radial_2953_26067)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6012 38.9499C36.3752 39.0791 36.3752 39.2891 36.6012 39.4183C36.8273 39.5475 37.1826 39.5475 37.4087 39.4183C37.6348 39.2891 37.6348 39.0791 37.4087 38.9499C37.1826 38.8208 36.8273 38.8208 36.6012 38.9499Z",
    fill: "url(#paint27_radial_2953_26067)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8081 38.9499C40.582 39.0791 40.582 39.2891 40.8081 39.4183C41.0342 39.5475 41.3894 39.5475 41.6155 39.4183C41.8416 39.2891 41.8416 39.0791 41.6155 38.9499C41.3894 38.8208 41.0342 38.8208 40.8081 38.9499Z",
    fill: "url(#paint28_radial_2953_26067)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7087 37.7388C38.4826 37.868 38.4826 38.0779 38.7087 38.2071C38.9348 38.3363 39.2901 38.3363 39.5162 38.2071C39.7422 38.0779 39.7422 37.868 39.5162 37.7388C39.2901 37.6096 38.9348 37.6096 38.7087 37.7388Z",
    fill: "url(#paint29_radial_2953_26067)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9155 37.7388C42.6894 37.868 42.6894 38.0779 42.9155 38.2071C43.1416 38.3363 43.4969 38.3363 43.723 38.2071C43.9491 38.0779 43.9491 37.868 43.723 37.7388C43.4969 37.6096 43.1416 37.6096 42.9155 37.7388Z",
    fill: "url(#paint30_radial_2953_26067)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8081 36.5195C40.582 36.6487 40.582 36.8586 40.8081 36.9878C41.0342 37.117 41.3894 37.117 41.6155 36.9878C41.8416 36.8586 41.8416 36.6487 41.6155 36.5195C41.3894 36.3903 41.0342 36.3903 40.8081 36.5195Z",
    fill: "url(#paint31_radial_2953_26067)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.023 36.5195C44.7969 36.6487 44.7969 36.8586 45.023 36.9878C45.2491 37.117 45.6043 37.117 45.8304 36.9878C46.0565 36.8586 46.0565 36.6487 45.8304 36.5195C45.6043 36.3903 45.2491 36.3903 45.023 36.5195Z",
    fill: "url(#paint32_radial_2953_26067)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9155 35.3083C42.6894 35.4375 42.6894 35.6475 42.9155 35.7767C43.1416 35.9059 43.4969 35.9059 43.723 35.7767C43.9491 35.6475 43.9491 35.4375 43.723 35.3083C43.4969 35.1791 43.1416 35.1791 42.9155 35.3083Z",
    fill: "url(#paint33_radial_2953_26067)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M45.023 34.0891C44.7969 34.2183 44.7969 34.4282 45.023 34.5574C45.2491 34.6866 45.6043 34.6866 45.8304 34.5574C46.0565 34.4282 46.0565 34.2183 45.8304 34.0891C45.6043 33.9599 45.2491 33.9599 45.023 34.0891Z",
    fill: "url(#paint34_radial_2953_26067)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4621 50.9164C15.2361 51.0456 15.2361 51.2555 15.4621 51.3847C15.6882 51.5139 16.0435 51.5139 16.2696 51.3847C16.4957 51.2555 16.4957 51.0456 16.2696 50.9164C16.0435 50.7872 15.6882 50.7872 15.4621 50.9164Z",
    fill: "url(#paint35_radial_2953_26067)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3547 49.7052C13.1286 49.8344 13.1286 50.0443 13.3547 50.1735C13.5808 50.3027 13.9361 50.3027 14.1621 50.1735C14.3882 50.0443 14.3882 49.8344 14.1621 49.7052C13.9361 49.576 13.5808 49.576 13.3547 49.7052Z",
    fill: "url(#paint36_radial_2953_26067)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2472 48.486C11.0211 48.6152 11.0211 48.8251 11.2472 48.9543C11.4733 49.0835 11.8286 49.0835 12.0547 48.9543C12.2808 48.8251 12.2808 48.6152 12.0547 48.486C11.8286 48.3568 11.4733 48.3568 11.2472 48.486Z",
    fill: "url(#paint37_radial_2953_26067)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.669 50.9164C19.4429 51.0456 19.4429 51.2555 19.669 51.3847C19.8951 51.5139 20.2503 51.5139 20.4764 51.3847C20.7025 51.2555 20.7025 51.0456 20.4764 50.9164C20.2503 50.7872 19.8951 50.7872 19.669 50.9164Z",
    fill: "url(#paint38_radial_2953_26067)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5615 49.7052C17.3354 49.8344 17.3354 50.0443 17.5615 50.1735C17.7876 50.3027 18.1429 50.3027 18.369 50.1735C18.5951 50.0443 18.5951 49.8344 18.369 49.7052C18.1429 49.576 17.7876 49.576 17.5615 49.7052Z",
    fill: "url(#paint39_radial_2953_26067)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4621 48.486C15.2361 48.6152 15.2361 48.8251 15.4621 48.9543C15.6882 49.0835 16.0435 49.0835 16.2696 48.9543C16.4957 48.8251 16.4957 48.6152 16.2696 48.486C16.0435 48.3568 15.6882 48.3568 15.4621 48.486Z",
    fill: "url(#paint40_radial_2953_26067)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3547 47.2748C13.1286 47.404 13.1286 47.6139 13.3547 47.7431C13.5808 47.8723 13.9361 47.8723 14.1621 47.7431C14.3882 47.6139 14.3882 47.404 14.1621 47.2748C13.9361 47.1456 13.5808 47.1456 13.3547 47.2748Z",
    fill: "url(#paint41_radial_2953_26067)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2472 46.0555C11.0211 46.1847 11.0211 46.3947 11.2472 46.5239C11.4733 46.653 11.8286 46.653 12.0547 46.5239C12.2808 46.3947 12.2808 46.1847 12.0547 46.0555C11.8286 45.9263 11.4733 45.9263 11.2472 46.0555Z",
    fill: "url(#paint42_radial_2953_26067)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2953_26067",
    x1: 39.8279,
    y1: 53.0073,
    x2: 5.10237,
    y2: 45.0379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2953_26067",
    x1: 43.4136,
    y1: 53.1102,
    x2: 8.8212,
    y2: 44.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2953_26067",
    x1: 26.8797,
    y1: 32.3649,
    x2: 17.5942,
    y2: 30.9294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2953_26067",
    x1: 17.6029,
    y1: 48.38,
    x2: 12.1443,
    y2: 47.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2953_26067",
    x1: 15.0719,
    y1: 20.8346,
    x2: -2.52452,
    y2: 15.5164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2953_26067",
    x1: 16.9236,
    y1: 22.0536,
    x2: 0.787364,
    y2: 17.4798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2953_26067",
    x1: 5.50633,
    y1: 19.1712,
    x2: -0.0303172,
    y2: 18.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2953_26067",
    x1: 15.4858,
    y1: 11.1698,
    x2: 12.3567,
    y2: 10.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2953_26067",
    x1: 12.3374,
    y1: 12.9861,
    x2: 9.20783,
    y2: 12.0392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2953_26067",
    x1: 9.187,
    y1: 14.8035,
    x2: 6.05744,
    y2: 13.8565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2953_26067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.413 38.0968) rotate(-162.538) scale(66.6089 22.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d5f2dab99809ff395f889fb481678765.svg";
export { ForwardRef as ReactComponent };